import * as actionTypes from "./ActionTypes";


export const clearStateAction = (stateName) => {
  return { type: actionTypes.CLEAR_STATE, stateName };
};

export const cacheAddPlanAction = (key, value) => {
  return { type: actionTypes.CACHE_ADD_PLAN, key, value };
};

export const toggleSocketIsListeningToPlanningAction = (state) => {
  return { type: actionTypes.TOGGLE_SOCKET_LISTENING_PLANNING, state };
};


export const getPlansAction = (query) => {
  return { type: actionTypes.GET_PLANS, query };
};
export const getPlansSuccessAction = (res) => {
  return { type: actionTypes.GET_PLANS_SUCCESS, res };
};
export const getPlansFailAction = (error) => {
  return { type: actionTypes.GET_PLANS_FAIL, error };
};


export const createPlanAction = (plan) => {
  return { type: actionTypes.CREATE_PLAN, plan };
};
export const createPlanSuccessAction = (res) => {
  return { type: actionTypes.CREATE_PLAN_SUCCESS, res };
};
export const createPlanFailAction = (error) => {
  return { type: actionTypes.CREATE_PLAN_FAIL, error };
};



export const downloadOptimizeFileAction = (plan) => {
  return { type: actionTypes.DOWNLOAD_OPTIMIZE_FILE, plan };
};
export const downloadOptimizeFileSuccessAction = (res) => {
  return { type: actionTypes.DOWNLOAD_OPTIMIZE_FILE_SUCCESS, res };
};
export const downloadOptimizeFileFailAction = (error) => {
  return { type: actionTypes.DOWNLOAD_OPTIMIZE_FILE_FAIL, error };
};



export const downloadExcelFileAction = (plan) => {
  return { type: actionTypes.DOWNLOAD_EXCEL_FILE, plan };
};
export const downloadExcelFileSuccessAction = (res) => {
  return { type: actionTypes.DOWNLOAD_EXCEL_FILE_SUCCESS, res };
};
export const downloadExcelFileFailAction = (error) => {
  return { type: actionTypes.DOWNLOAD_EXCEL_FILE_FAIL, error };
};



export const downloadPlanFormAction = (plan) => {
  return { type: actionTypes.DOWNLOAD_PLAN_FORM, plan };
};
export const downloadPlanFormSuccessAction = (res) => {
  return { type: actionTypes.DOWNLOAD_PLAN_FORM_SUCCESS, res };
};
export const downloadPlanFormFailAction = (error) => {
  return { type: actionTypes.DOWNLOAD_PLAN_FORM_FAIL, error };
};


export const deletePlanAction = (id) => {
  return { type: actionTypes.DELETE_PLAN, id };
};
export const deletePlanSuccessAction = (res) => {
  return { type: actionTypes.DELETE_PLAN_SUCCESS, res };
};
export const deletePlanFailAction = (error) => {
  return { type: actionTypes.DELETE_PLAN_FAIL, error };
};


export const updatePlanAction = (plan) => {
  return { type: actionTypes.UPDATE_PLAN, plan };
};
export const updatePlanSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_PLAN_SUCCESS, res };
};
export const updatePlanFailAction = (error) => {
  return { type: actionTypes.UPDATE_PLAN_FAIL, error };
};


export const errorPlanMessageAction = (id) => {
  return { type: actionTypes.ERROR_PLAN_MESSAGE, id };
};
export const errorPlanMessageSuccessAction = (res) => {
  return { type: actionTypes.ERROR_PLAN_MESSAGE_SUCCESS, res };
};
export const errorPlanMessageFailAction = (error) => {
  return { type: actionTypes.ERROR_PLAN_MESSAGE_FAIL, error };
};


export const postPlanConfigAction = (config) => {
  return { type: actionTypes.POST_PLAN_CONFIG, config };
};
export const postPlanConfigSuccessAction = (res) => {
  return { type: actionTypes.POST_PLAN_CONFIG_SUCCESS, res };
};
export const postPlanConfigFailAction = (error) => {
  return { type: actionTypes.POST_PLAN_CONFIG_FAIL, error };
};


export const restorePlanAction = (data) => {
  return { type: actionTypes.RESTORE_PLAN, data };
};
export const restorePlanSuccessAction = (res) => {
  return { type: actionTypes.RESTORE_PLAN_SUCCESS, res };
};
export const restorePlanFailAction = (error) => {
  return { type: actionTypes.RESTORE_PLAN_FAIL, error };
};


export const RestoreDriverAction = (data) => {
  return { type: actionTypes.RESTORE_DRIVER, data };
};
export const RestoreDriverSuccessAction = (res) => {
  return { type: actionTypes.RESTORE_DRIVER_SUCCESS, res };
};
export const RestoreDriverFailAction = (error) => {
  return { type: actionTypes.RESTORE_DRIVER_FAIL, error };
};


export const executePlanAction = (plan) => {
  return { type: actionTypes.EXECUTE_PLAN, plan };
};
export const executePlanSuccessAction = (res) => {
  return { type: actionTypes.EXECUTE_PLAN_SUCCESS, res };
};
export const executePlanFailAction = (error) => {
  return { type: actionTypes.EXECUTE_PLAN_FAIL, error };
};


export const getAllPlansListAction = (query) => {
  return { type: actionTypes.GET_ALL_PLANS, query };
};
export const getAllPlansListSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_PLANS_SUCCESS, res };
};
export const getAllPlansListFailAction = (error) => {
  return { type: actionTypes.GET_ALL_PLANS_FAIL, error };
};


export const getFromExternalSourceAction = (data) => {
  return { type: actionTypes.GET_FROM_EXTERNAL_SOURCE, data };
};
export const getFromExternalSourceSuccessAction = (res, name) => {
  return { type: actionTypes.GET_FROM_EXTERNAL_SOURCE_SUCCESS, res, name };
};
export const getFromExternalSourceFailAction = (error) => {
  return { type: actionTypes.GET_FROM_EXTERNAL_SOURCE_FAIL, error };
};


export const getPlanLogsAction = (data) => {
  return { type: actionTypes.GET_PLAN_LOGS, data };
};
export const getPlanLogsSuccessAction = (res, name) => {
  return { type: actionTypes.GET_PLAN_LOGS_SUCCESS, res, name };
};
export const getPlanLogsFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_LOGS_FAIL, error };
};


export const getToolNameListAction = (data) => {
  return { type: actionTypes.GET_TOOLNAME_LIST, data };
};
export const getToolNameListSuccessAction = (res) => {
  return { type: actionTypes.GET_TOOLNAME_LIST_SUCCESS, res };
};
export const getToolNameListFailAction = (error) => {
  return { type: actionTypes.GET_TOOLNAME_LIST_FAIL, error };
};


export const missionInfoByOrderIdAction = (data) => {
  return { type: actionTypes.MISSION_INFO_BY_ORDER_ID, data };
};
export const missionInfoByOrderIdSuccessAction = (res) => {
  return { type: actionTypes.MISSION_INFO_BY_ORDER_ID_SUCCESS, res };
};
export const missionInfoByOrderIdFailAction = (error) => {
  return { type: actionTypes.MISSION_INFO_BY_ORDER_ID_FAIL, error };
};